/** @jsxRuntime classic */
/** @jsx jsx */

import { jsx } from '@emotion/react';
import { LogoBar as LogoBarZDS, LogoBarProps } from '@zapier/design-system';

type Props = LogoBarProps;

export function LogoBarV2({ title, items, size }: Props) {
  return <LogoBarZDS title={title} items={items} size={size} />;
}
